import OverlayTips from "../OverlayTips";

function BillingTypesPageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
}

BillingTypesPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {
    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($(".pagetitle span"), {
            messageKey: "tips.billing_types.title",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -10,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT
            }
        });

        this.add($(".billingTypeCell").eqOrLast(4) , {
            messageKey: "tips.billing_types.edit",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: -80
            }
        });

        this.add(function() { return $(".billableStatusCell").not(".nonBillableDefault").eqOrLast(1)}  , {
            messageKey: "tips.billing_types.billable_non_billable",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: -10
        });
    }
});

export default BillingTypesPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/js/tips/managers/BillingTypesPageOverlayTipsManager.js